export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-950">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-white">
              <i className="ri-smartphone-line text-accent-400 mr-2"></i>随时随地 · 掌上吃瓜
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-300 leading-relaxed max-w-lg">
              下载黑料吃瓜App，享受更流畅的高清视频播放体验。支持离线缓存、个性化推荐和消息推送，不错过任何一条热门吃瓜内容。黑料吃瓜短视频随时随地轻松刷，做您口袋里的吃瓜神器。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-3 justify-center lg:justify-start">
              <div className="flex items-center gap-2 px-5 py-3 rounded-xl bg-background-800/50 border border-background-700/50 text-white cursor-pointer hover:bg-background-700/50 transition-colors">
                <i className="ri-android-line text-xl text-accent-400"></i>
                <div>
                  <div className="text-[10px] text-background-400">Android 下载</div>
                  <div className="text-sm font-semibold whitespace-nowrap">安卓客户端</div>
                </div>
              </div>
              <div className="flex items-center gap-2 px-5 py-3 rounded-xl bg-background-800/50 border border-background-700/50 text-white cursor-pointer hover:bg-background-700/50 transition-colors">
                <i className="ri-apple-line text-xl text-accent-400"></i>
                <div>
                  <div className="text-[10px] text-background-400">iOS 下载</div>
                  <div className="text-sm font-semibold whitespace-nowrap">苹果客户端</div>
                </div>
              </div>
            </div>

            <div className="mt-5 flex items-center gap-4 justify-center lg:justify-start text-xs text-background-400">
              <span><i className="ri-shield-check-line mr-1"></i>安全纯净</span>
              <span><i className="ri-download-2-line mr-1"></i>极速下载</span>
              <span><i className="ri-device-line mr-1"></i>多端同步</span>
            </div>
          </div>

          <div className="flex-shrink-0">
            <div className="relative w-64 h-[420px] rounded-2xl overflow-hidden border-2 border-background-700/50">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20showing%20entertainment%20news%20feed%20with%20dark%20theme%2C%20warm%20red%20and%20amber%20accent%20cards%2C%20video%20thumbnails%20with%20play%20buttons%2C%20modern%20app%20interface%20design%2C%20no%20text%2C%20clean%20layout%2C%20dark%20background%2C%20glowing%20warm%20highlights&width=640&height=1136&seq=app-mockup-2026&orientation=portrait"
                alt="黑料吃瓜App界面展示"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}